const DIRECTION_COPY_KEY = {
    down: 'directionDown',
    left: 'directionLeft',
    right: 'directionRight',
    up: 'directionUp',
};

export const formatGameCopy = (template = '', replacements = {}) => Object.entries(replacements).reduce(
    (message, [key, value]) => message.split(`{${key}}`).join(`${value}`),
    `${template || ''}`
);

export const getDirectionLabel = (copy = {}, direction = '') => (
    copy[DIRECTION_COPY_KEY[direction]] || direction
);

